import appConfig from 'application-config';
import _ from 'lodash';

import { parseURL } from 'common/utils';
import { ORIGINAL_IMAGE_IDENTIFIER } from '../../../functions/common/constants.json';

export function uploadMedia(firebase) {
	return async (file, options = {}) => {
		const ref = firebase.storage().ref();
		let originalFileName;
		let name;

		if (file.type.includes('video')) {
			name = `videos/${+new Date()}-${file.name}`;
		} else {
			originalFileName = file.name.replace(/\.(?!.*\.)/, `${ORIGINAL_IMAGE_IDENTIFIER}.`);
			name = `images/${+new Date()}-${originalFileName}`;
		}

		// upload static images, e.g. "share image".
		if (options.isStatic) {
			const extension = options.extension || _.last(file.name.split('.'));
			name = `static/${`${options.filename}.${extension}`}`;
		}
		const metadata = {
			contentType: file.type,
		};
		const task = ref.child(name).put(file, metadata);
		return task
			.then(snapshot => snapshot.ref.getDownloadURL())
			.then(url => {
				const { pathname, search } = parseURL(url);
				const CDN_URL = [appConfig.cdn.hostname, pathname, search].join('');
				return {
					url: CDN_URL,
					name: originalFileName,
				};
			})
			.catch(console.error);
	};
}
